<div class="kf-editable-field">
    @if (isEditable$ | async; as editable) {
        <div class="d-flex
             {{'kf-field-xs-' + labelCols}}
             {{'kf-field-sm-' + labelColsSm}}
             {{'kf-field-md-' + labelColsMd}}
             {{'kf-field-lg-' + labelColsLg}}
             {{'kf-field-xl-' + labelColsXl}}
             {{'kf-field-xxl-' + labelColsXxl}}">
            <div class="kf-input-label">
                <label for="{{id}}">
                    {{label}}
                    @if (helpText) {
                        <span class="me-2 kf-tooltip" [ngbTooltip]="helpText" [placement]="['top', 'right']">
                            <i class="fas fa-info-circle"></i><span class="sr-only">{{helpText}}</span>
                        </span>
                    }
                </label>
            </div>
            <div class="kf-input col">
                <!-- The checkbox that holds the value and isbound to the property, but not shown to the user.
                This is currently used with it's "checked" status in CSS to drive the style of the slider.
                Once me move to the built-in slider, we should be able to remove this.
                -->
                <input type="checkbox" class="checkbox"
                       [name]="obj"
                       [id]="id"
                       [(ngModel)]="obj[prop]">
                <!-- The slider the user sees. It changes the value of the bound checkbox. -->
                <div class="switch-toggle-size">
                    <div class="switch" tabindex="0"
                         (click)="onChange()"
                         (keyup.enter)="onChange()"
                         (keyup.space)="onChange()"
                         [ngClass]="{'switch-sm' : size == 'sm'}">
                        @if (!obj[prop]) {
                            <span class="switch-text left noselect">{{falseLabel}}</span>
                        }
                        @if (obj[prop]) {
                            <span class="switch-text right noselect">{{trueLabel}}</span>
                        }
                    </div>
                </div>
            </div>
        </div>
        
        <!--  Errors/Warnings  -->
        <observable-errors-warnings [obj]="obj" [props]="[prop]" [useSingleAlert]="true"></observable-errors-warnings>
    }
    @else {
        <div class="d-flex
             {{'kf-field-xs-' + labelCols}}
             {{'kf-field-sm-' + labelColsSm}}
             {{'kf-field-md-' + labelColsMd}}
             {{'kf-field-lg-' + labelColsLg}}
             {{'kf-field-xl-' + labelColsXl}}
             {{'kf-field-xxl-' + labelColsXxl}}">
            <div class="kf-input-label">
                <div class="kf-label">
                    {{label}}
                    @if (helpText) {
                        <span class="me-2 kf-tooltip" [ngbTooltip]="helpText" [placement]="['top', 'right']">
                            <i class="fas fa-info-circle"></i><span class="sr-only">{{helpText}}</span>
                        </span>
                    }
                </div>
            </div>
            <div class="kf-input col">{{readOnlyValue$ | async}}</div>
        </div>
        @if (!!allowReadOnlyWarnings) {
            @if (this.warning$ | async; as warning) {
                <!--  Optionally show warnings only in read-only mode  -->
                <observable-errors-warnings [obj]="obj" [props]="[prop]" [useSingleAlert]="true" [supressErrors]="true"></observable-errors-warnings>
            }
        }
    }
</div>

